import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AccountSelectors } from '@serviceos-ng/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'serviceos-web-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit, OnDestroy {
    avatar = null;
    avatar$!: Observable<any>;
    iconHight = 0;
    @HostListener('window:resize', ['$event'])
    onResizeHandler(event: Event): void {
        this.resize();
    }

    constructor(
        public store: Store,
        private elementRef: ElementRef,
        public cdRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.avatar$ = this.store.select(AccountSelectors.avatar).pipe(
            tap((res) => {
                this.resize();
            })
        );
    }

    ngAfterViewInit() {
        this.resize();
    }

    resize() {
        if (this.iconHight != this.elementRef.nativeElement.offsetHeight) {
            this.iconHight = this.elementRef.nativeElement.offsetHeight;
            this.cdRef.detectChanges();
        }
    }

    ngOnDestroy(): void {}
}
